<script>import OpenGraph from "./open-graph.svelte";
import SchemaOrg from "./schema-org.svelte";
import Twitter from "./twitter.svelte";
import Canonical from "./canonical.svelte";
import H1 from "./h1.svelte";
import Favicon from "./favicon.svelte";
export let siteName;
export let siteUrl;
export let language = "en_GB";
export let defaultTitle;
export let defaultMetaDescription;
export let defaultDate;
export let settings = {
  canonical: true,
  twitter: true,
  openGraph: true,
  schemaOrg: true
};
export let url = siteUrl;
export let title = defaultTitle;
export let metaDescription = defaultMetaDescription;
export let h1 = "";
export let metaImage = {
  url: "",
  alt: "",
  caption: "",
  width: 0,
  height: 0
};
export let datePublished = defaultDate;
export let dateUpdated = defaultDate;
export let pageType = "general";
export let breadcrumbs = [
  {
    name: "",
    slug: "/"
  }
];
export let artist = {
  name: "",
  first_name: "",
  last_name: "",
  nickname: "",
  image: "",
  sameAs: [],
  jobTitle: "artist",
  worksFor: {
    name: ""
  }
};
export let artwork = {
  name: "",
  description: "",
  dateCreated: "",
  image: "",
  artEdition: "",
  artMedium: "",
  artform: "",
  artist: "",
  artworkSurface: "",
  height: "",
  width: "",
  depth: ""
};
export let openGraph = null;
export let faviconHtml = null;
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content="{metaDescription}" />
  <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
</svelte:head>

{#if faviconHtml}
  <Favicon {faviconHtml} />
{/if}

{#if settings.canonical}
  <Canonical {breadcrumbs} {siteUrl} />
{/if}

{#if settings.twitter}
  <Twitter {title} {metaDescription} {metaImage} />
{/if}

{#if settings.openGraph}
  <OpenGraph {title} {metaDescription} {siteName} {language} {url} {metaImage} {openGraph} />
{/if}

{#if settings.schemaOrg}
  <SchemaOrg
    {pageType}
    {title}
    {defaultTitle}
    {metaDescription}
    {defaultMetaDescription}
    {metaImage}
    {datePublished}
    {dateUpdated}
    {language}
    {artist}
    {artwork}
    {url}
    {siteUrl}
  />
{/if}

{#if h1}
  <H1 {h1} />
{/if}
